/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useEffect } from "react"; 
import { Link, Outlet } from "react-router-dom";

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../../components/recoil/atoms/Menus";

import logoImage from "../../../img/logo/logo.svg";
import mainlogoImage from "../../../img/logo/logo-w.svg";

const ParentFlatForm = () => {

  const [varParentsMenus] = useRecoilState(ParentsMenus);

  useEffect(() => {
    //페이지 크기 재설정
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-container">
      <header id="header" className={varParentsMenus.gotoMain===-1?"main-header":varParentsMenus.gotoMain===0?"header":"logo-head"}>
        {varParentsMenus.gotoMain===-1?<div className="hd-logo"><img src={mainlogoImage} alt="" /></div>
        :varParentsMenus.gotoMain===0||varParentsMenus.gotoMain===1?<Link to={'/MainParent'} className="hd-logo"><img src={logoImage} alt="" /></Link>
        :<div className="hd-logo"><img src={logoImage} alt="" /></div>
        }
      </header>
      <Outlet/>
    </div>
  );
}
export default ParentFlatForm;